<template>
  <div
    class="wl-taste-profile"
    :class="'wl-taste-profile--' + taste.type.toLowerCase()"
  >
    <section
      class="wl-taste-profile__profile"
      v-if="taste.profile"
    >
      <header
        class="wl-taste-profile__headline"
        v-if="isHeadlineVisible"
      >
        {{ $t('wl_taste_profile.head.profile') }}
      </header>
      <div class="wl-taste-profile__histogram">
        <div
          class="wl-taste-profile__histogram-line"
          v-for="entry in taste.profile"
          :key="entry.label"
        >
          <span class="wl-taste-profile__histogram-label">
            {{ entry.label }}
          </span>
          <div class="wl-taste-profile__histogram-bar">
            <div
              class="wl-taste-profile__histogram-fill"
              :style="`width: ${entry.value * 100}%`"
            >
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      class="wl-taste-profile__aroma"
      v-if="taste.aroma && taste.aroma.length"
    >
      <header
        class="wl-taste-profile__headline"
        v-if="isHeadlineVisible"
      >
        {{ $t('wl_taste_profile.head.aroma') }}
      </header>

      <ul
        class="wl-taste-profile__aroma-list"
      >
        <li
          class="wl-taste-profile__aroma-item"
          v-for="aroma in taste.aroma"
          :key="aroma.label"
        >
          <div
            class="wl-taste-profile__aroma-img"
            :style="`background: url(${aroma.image})`"
          />
          <div class="wl-taste-profile__aroma-label">
            {{ aroma.label }}
          </div>
        </li>
      </ul>
    </section>

    <section
      class="wl-taste-profile__style"
      v-if="taste.style"
    >
      <header
        class="wl-taste-profile__headline"
        v-if="isHeadlineVisible"
      >
        {{ $t('wl_taste_profile.head.style.' + taste.type.toUpperCase()) }}
      </header>
      <div class="wl-taste-profile__style-content">
        <img
          class="wl-taste-profile__style-img"
          :src="taste.style.image"
          alt=""
        >
        <div
          class="wl-taste-profile__style-text"
          v-if="taste.style.taste || taste.style.aftertaste"
        >
          <p
            class="wl-taste-profile__style-taste"
            v-if="taste.style.taste"
          >
            <strong>{{ $t('wl_taste_profile.style.taste') }}</strong>
            <span v-html="taste.style.taste" />
          </p>
          <p
            class="wl-taste-profile__style-aftertaste"
            v-if="taste.style.aftertaste"
          >
            <strong>{{ $t('wl_taste_profile.style.aftertaste') }}</strong>
            <span v-html="taste.style.aftertaste" />
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
  import {Vue, Prop, Options} from 'vue-property-decorator';
  import type WineLuthierTaste from '../../types/WineLuthierTaste';
  import LazyLoad from '../../../bps/components/lazyLoad/lazyLoad.vue';

  @Options({
    name: 'wl-taste-profile',
    components: {
      LazyLoad
    }
  })
  export default class WlTasteProfile extends Vue {
    @Prop()
    taste: WineLuthierTaste;

    get isHeadlineVisible(): boolean {
      if (!this.taste) return false;

      const data = [
        this.taste.aroma,
        this.taste.profile,
        this.taste.style
      ].filter(e => !!e)

      return data.length >= 2;
    }
  }
</script>
